import { ReactNode } from 'react'
import { Container } from 'semantic-ui-react'
import { path } from '../../../routes/paths'
import { Header } from './Header'
import { MenuItem } from './Header/MenuItem'

type Props = {
  children: ReactNode
}

const menus: MenuItem[] = [
  { type: 'link', to: '/', label: 'Home' },
  {
    type: 'menu',
    label: 'Impostazioni',
    items: [{ type: 'link', label: 'Stop Template', to: path('/general/stop-templates') }],
  },
]

export const BaseLayout = ({ children }: Props) => {
  return (
    <div>
      <Header appName={'Budget Flow'} menus={menus} />
      <Container>{children}</Container>
    </div>
  )
}
